/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserPrefsInput = {
  username: string,
  inputs?: InputsPrefsInput | null,
  lastSite?: UserPrefSiteInput | null,
  readersAlarms?: ReadersAlarmsPrefsInput | null,
  readersModes?: ReadersModesPrefsInput | null,
  site?: string | null,
  sites?: Array< UserPrefSiteInput | null > | null,
};

export type InputsPrefsInput = {
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?: Array< InputsSavedSearchInput | null > | null,
};

export type InputsSavedSearchInput = {
  name: string,
  filterText?: string | null,
  maskStatus?: string | null,
  modes?: Array< string | null > | null,
};

export type UserPrefSiteInput = {
  sitename: string,
  siteRegion?: string | null,
};

export type ReadersAlarmsPrefsInput = {
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?: Array< ReadersAlarmsSavedSearchInput | null > | null,
};

export type ReadersAlarmsSavedSearchInput = {
  name: string,
  filterText?: string | null,
  maskStatus?: string | null,
  modes?: Array< string | null > | null,
};

export type ReadersModesPrefsInput = {
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?: Array< ReadersSavedSearchInput | null > | null,
};

export type ReadersSavedSearchInput = {
  name: string,
  filterText?: string | null,
  maskStatus?: string | null,
  modes?: Array< string | null > | null,
};

export type UserPrefs = {
  __typename: "UserPrefs",
  username?: string,
  inputs?: InputsPrefs,
  lastSite?: UserPrefSite,
  readersAlarms?: ReadersAlarmsPrefs,
  readersModes?: ReadersModesPrefs,
  site?: string | null,
  sites?:  Array<UserPrefSite | null > | null,
};

export type InputsPrefs = {
  __typename: "InputsPrefs",
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?:  Array<InputsSavedSearch | null > | null,
};

export type InputsSavedSearch = {
  __typename: "InputsSavedSearch",
  name?: string,
  filterText?: string | null,
  maskStatus?: string | null,
  modes?: Array< string | null > | null,
};

export type UserPrefSite = {
  __typename: "UserPrefSite",
  sitename?: string,
  siteRegion?: string | null,
};

export type ReadersAlarmsPrefs = {
  __typename: "ReadersAlarmsPrefs",
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?:  Array<ReadersAlarmsSavedSearch | null > | null,
};

export type ReadersAlarmsSavedSearch = {
  __typename: "ReadersAlarmsSavedSearch",
  name?: string,
  filterText?: string | null,
  maskStatus?: string | null,
  modes?: Array< string | null > | null,
};

export type ReadersModesPrefs = {
  __typename: "ReadersModesPrefs",
  numRecordsPerPage?: number | null,
  emailAddresses?: string | null,
  savedSearches?:  Array<ReadersAlarmsSavedSearch | null > | null,
};

export type UpdateUserPrefsInput = {
  username: string,
  inputs?: InputsPrefsInput | null,
  readersAlarms?: ReadersAlarmsPrefsInput | null,
  readersModes?: ReadersModesPrefsInput | null,
  site?: string | null,
  sites?: Array< UserPrefSiteInput | null > | null,
};

export type DeleteUserPrefsInput = {
  username: string,
};

export type UserActionInput = {
  actionId: string,
  actionName: string,
  timestamp: string,
  username: string,
  parameters?: string | null,
};

export type UserAction = {
  __typename: "UserAction",
  actionId?: string,
  actionName?: string,
  timestamp?: string,
  username?: string,
  parameters?: string | null,
};

export type SetReaderModeInput = {
  deviceSource: string,
  devices: Array< SetDeviceInput | null >,
  emails: string,
  method: HTTPMethod,
  mode: string,
  path: string,
  processWithDelaySeconds: number,
  requestedBy: string,
  siteName: string,
  siteRegion: string,
};

export type SetDeviceInput = {
  deviceName: string,
  deviceHref?: string | null,
};

export enum HTTPMethod {
  delete = "delete",
  get = "get",
  post = "post",
  put = "put",
}


export type SetReaderModeResponse = {
  __typename: "SetReaderModeResponse",
  devices?:  Array<SetDeviceResponse | null > | null,
  message?: string | null,
  requestUUID?: string | null,
  status?: number | null,
};

export type SetDeviceResponse = {
  __typename: "SetDeviceResponse",
  deviceName?: string,
  status?: string | null,
};

export type SetInputMaskInput = {
  deviceSource: string,
  devices: Array< SetDeviceInput | null >,
  emails: string,
  masked: boolean,
  method: HTTPMethod,
  path: string,
  processWithDelaySeconds: number,
  requestedBy: string,
  siteName: string,
  siteRegion: string,
};

export type SetInputMaskResponse = {
  __typename: "SetInputMaskResponse",
  devices?:  Array<SetDeviceResponse | null > | null,
  message?: string | null,
  requestUUID?: string | null,
  status?: number | null,
};

export type SetReaderDoorHeldMaskInput = {
  deviceSource: string,
  devices: Array< SetDeviceInput | null >,
  emails: string,
  masked: boolean,
  method: HTTPMethod,
  path: string,
  processWithDelaySeconds: number,
  requestedBy: string,
  siteName: string,
  siteRegion: string,
};

export type SetReaderDoorHeldMaskResponse = {
  __typename: "SetReaderDoorHeldMaskResponse",
  devices?:  Array<SetDeviceResponse | null > | null,
  message?: string | null,
  requestUUID?: string | null,
  status?: number | null,
};

export type SetReaderDoorForcedMaskInput = {
  deviceSource: string,
  devices: Array< SetDeviceInput | null >,
  emails: string,
  masked: boolean,
  method: HTTPMethod,
  path: string,
  processWithDelaySeconds: number,
  requestedBy: string,
  siteName: string,
  siteRegion: string,
};

export type SetReaderDoorForcedMaskResponse = {
  __typename: "SetReaderDoorForcedMaskResponse",
  devices?:  Array<SetDeviceResponse | null > | null,
  message?: string | null,
  requestUUID?: string | null,
  status?: number | null,
};

export type SetPACSDataAPIReaderMaskResponse = {
  __typename: "SetPACSDataAPIReaderMaskResponse",
  status?: number | null,
};

export type ChildDevice = {
  __typename: "ChildDevice",
  Child_DeviceID?: number | null,
  device_href?: string | null,
  Device_Type?: string | null,
  DeviceName?: string | null,
  devicesource?: string | null,
  DoorForcedMasked?: boolean | null,
  DoorHeldMasked?: boolean | null,
  Parent_DeviceID?: number | null,
  SegmentID?: number | null,
  Subchild_DeviceID?: number | null,
  Masked?: boolean | null,
  Mode?: string | null,
};

export type ListDeviceStatusForSitesInput = {
  SITE_CODES: string,
};

export type DeviceStatus = {
  __typename: "DeviceStatus",
  device_key?: string | null,
  parent_id?: number | null,
  child_id?: number | null,
  subchild_id?: number | null,
  site_code?: string | null,
  device_type?: string | null,
  masked?: boolean | null,
  masked_timestamp?: string | null,
  intrusion_report?: string | null,
  intrusion_report_timestamp?: string | null,
  alarm?: boolean | null,
  alarm_timestamp?: string | null,
  line_error?: boolean | null,
  line_error_timestamp?: string | null,
  open_line?: boolean | null,
  open_line_timestamp?: string | null,
  shorted_line?: boolean | null,
  shorted_line_timestamp?: string | null,
  grounded_loop?: boolean | null,
  grounded_loop_timestamp?: string | null,
  relay_contact?: boolean | null,
  relay_contact_timestamp?: string | null,
  comm_loss?: boolean | null,
  comm_loss_timestamp?: string | null,
  comm_loss_host?: boolean | null,
  comm_loss_host_timestamp?: string | null,
  door_forced?: boolean | null,
  door_forced_timestamp?: string | null,
  door_held?: boolean | null,
  door_held_timestamp?: string | null,
  reader_mode?: string | null,
  reader_mode_timestamp?: string | null,
  full_panel_download?: boolean | null,
  full_panel_download_timestamp?: string | null,
  cabinet_tamper?: boolean | null,
  cabinet_tamper_timestamp?: string | null,
  power_failure?: boolean | null,
  power_failure_timestamp?: string | null,
  door_held_masked?: boolean | null,
  door_held_masked_timestamp?: string | null,
  door_forced_masked?: boolean | null,
  door_forced_masked_timestamp?: string | null,
  comm_path?: boolean | null,
  comm_path_timestamp?: string | null,
  last_update_epoch_utc?: string | null,
};

export type FacmanUserSites = {
  __typename: "FacmanUserSites",
  sitesTotal?: number | null,
  sites?:  Array<FacmanSite | null > | null,
  error?: string | null,
};

export type FacmanSite = {
  __typename: "FacmanSite",
  siteId?: string,
  siteName?: string,
  region?: string | null,
  siteType?: string | null,
};

export type SIGInfraSite = {
  __typename: "SIGInfraSite",
  SiteCode?: string,
  AccessLevelName?: string,
  BadgeKey?: number,
  BadgeID?: number,
  Login?: string,
  Region?: string | null,
};

export type GetDeviceStatusInput = {
  PARENT_DEVICE_ID: string,
  CHILD_DEVICE_ID: string,
  SUBCHILD_DEVICE_ID: string,
};

export type CreateUserPrefsMutationVariables = {
  input?: CreateUserPrefsInput,
};

export type CreateUserPrefsMutation = {
  createUserPrefs?:  {
    __typename: "UserPrefs",
    username: string,
    inputs?:  {
      __typename: "InputsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "InputsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    lastSite?:  {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null,
    readersAlarms?:  {
      __typename: "ReadersAlarmsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    readersModes?:  {
      __typename: "ReadersModesPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    site?: string | null,
    sites?:  Array< {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null > | null,
  } | null,
};

export type UpdateUserPrefsMutationVariables = {
  input?: UpdateUserPrefsInput,
};

export type UpdateUserPrefsMutation = {
  updateUserPrefs?:  {
    __typename: "UserPrefs",
    username: string,
    inputs?:  {
      __typename: "InputsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "InputsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    lastSite?:  {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null,
    readersAlarms?:  {
      __typename: "ReadersAlarmsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    readersModes?:  {
      __typename: "ReadersModesPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    site?: string | null,
    sites?:  Array< {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null > | null,
  } | null,
};

export type DeleteUserPrefsMutationVariables = {
  input?: DeleteUserPrefsInput,
};

export type DeleteUserPrefsMutation = {
  deleteUserPrefs?:  {
    __typename: "UserPrefs",
    username: string,
    inputs?:  {
      __typename: "InputsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "InputsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    lastSite?:  {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null,
    readersAlarms?:  {
      __typename: "ReadersAlarmsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    readersModes?:  {
      __typename: "ReadersModesPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    site?: string | null,
    sites?:  Array< {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null > | null,
  } | null,
};

export type CreateUserActionMutationVariables = {
  input?: UserActionInput,
};

export type CreateUserActionMutation = {
  createUserAction?:  {
    __typename: "UserAction",
    actionId: string,
    actionName: string,
    timestamp: string,
    username: string,
    parameters?: string | null,
  } | null,
};

export type UpdateUserActionMutationVariables = {
  input?: UserActionInput,
};

export type UpdateUserActionMutation = {
  updateUserAction?:  {
    __typename: "UserAction",
    actionId: string,
    actionName: string,
    timestamp: string,
    username: string,
    parameters?: string | null,
  } | null,
};

export type SetReaderModeMutationVariables = {
  input?: SetReaderModeInput,
};

export type SetReaderModeMutation = {
  setReaderMode?:  {
    __typename: "SetReaderModeResponse",
    devices?:  Array< {
      __typename: "SetDeviceResponse",
      deviceName: string,
      status?: string | null,
    } | null > | null,
    message?: string | null,
    requestUUID?: string | null,
    status?: number | null,
  } | null,
};

export type SetInputMaskMutationVariables = {
  input?: SetInputMaskInput,
};

export type SetInputMaskMutation = {
  setInputMask?:  {
    __typename: "SetInputMaskResponse",
    devices?:  Array< {
      __typename: "SetDeviceResponse",
      deviceName: string,
      status?: string | null,
    } | null > | null,
    message?: string | null,
    requestUUID?: string | null,
    status?: number | null,
  } | null,
};

export type SetReaderDoorHeldMaskMutationVariables = {
  input?: SetReaderDoorHeldMaskInput,
};

export type SetReaderDoorHeldMaskMutation = {
  setReaderDoorHeldMask?:  {
    __typename: "SetReaderDoorHeldMaskResponse",
    devices?:  Array< {
      __typename: "SetDeviceResponse",
      deviceName: string,
      status?: string | null,
    } | null > | null,
    message?: string | null,
    requestUUID?: string | null,
    status?: number | null,
  } | null,
};

export type SetReaderDoorForcedMaskMutationVariables = {
  input?: SetReaderDoorForcedMaskInput,
};

export type SetReaderDoorForcedMaskMutation = {
  setReaderDoorForcedMask?:  {
    __typename: "SetReaderDoorForcedMaskResponse",
    devices?:  Array< {
      __typename: "SetDeviceResponse",
      deviceName: string,
      status?: string | null,
    } | null > | null,
    message?: string | null,
    requestUUID?: string | null,
    status?: number | null,
  } | null,
};

export type SetPacsDataApiReaderMaskMutationVariables = {
  path?: string,
};

export type SetPacsDataApiReaderMaskMutation = {
  setPACSDataAPIReaderMask?:  {
    __typename: "SetPACSDataAPIReaderMaskResponse",
    status?: number | null,
  } | null,
};

export type ListChildDevicesQueryVariables = {
  path?: string,
};

export type ListChildDevicesQuery = {
  listChildDevices?:  Array< {
    __typename: "ChildDevice",
    Child_DeviceID?: number | null,
    device_href?: string | null,
    Device_Type?: string | null,
    DeviceName?: string | null,
    devicesource?: string | null,
    DoorForcedMasked?: boolean | null,
    DoorHeldMasked?: boolean | null,
    Parent_DeviceID?: number | null,
    SegmentID?: number | null,
    Subchild_DeviceID?: number | null,
    Masked?: boolean | null,
    Mode?: string | null,
  } | null > | null,
};

export type ListDeviceStatusForSitesQueryVariables = {
  queryStringParameters?: ListDeviceStatusForSitesInput,
};

export type ListDeviceStatusForSitesQuery = {
  listDeviceStatusForSites?:  Array< {
    __typename: "DeviceStatus",
    device_key?: string | null,
    parent_id?: number | null,
    child_id?: number | null,
    subchild_id?: number | null,
    site_code?: string | null,
    device_type?: string | null,
    masked?: boolean | null,
    masked_timestamp?: string | null,
    intrusion_report?: string | null,
    intrusion_report_timestamp?: string | null,
    alarm?: boolean | null,
    alarm_timestamp?: string | null,
    line_error?: boolean | null,
    line_error_timestamp?: string | null,
    open_line?: boolean | null,
    open_line_timestamp?: string | null,
    shorted_line?: boolean | null,
    shorted_line_timestamp?: string | null,
    grounded_loop?: boolean | null,
    grounded_loop_timestamp?: string | null,
    relay_contact?: boolean | null,
    relay_contact_timestamp?: string | null,
    comm_loss?: boolean | null,
    comm_loss_timestamp?: string | null,
    comm_loss_host?: boolean | null,
    comm_loss_host_timestamp?: string | null,
    door_forced?: boolean | null,
    door_forced_timestamp?: string | null,
    door_held?: boolean | null,
    door_held_timestamp?: string | null,
    reader_mode?: string | null,
    reader_mode_timestamp?: string | null,
    full_panel_download?: boolean | null,
    full_panel_download_timestamp?: string | null,
    cabinet_tamper?: boolean | null,
    cabinet_tamper_timestamp?: string | null,
    power_failure?: boolean | null,
    power_failure_timestamp?: string | null,
    door_held_masked?: boolean | null,
    door_held_masked_timestamp?: string | null,
    door_forced_masked?: boolean | null,
    door_forced_masked_timestamp?: string | null,
    comm_path?: boolean | null,
    comm_path_timestamp?: string | null,
    last_update_epoch_utc?: string | null,
  } | null > | null,
};

export type ListFacmanUserSitesQueryVariables = {
  sitename?: string | null,
  groupname?: string | null,
  username?: string | null,
  employeeId?: number | null,
};

export type ListFacmanUserSitesQuery = {
  listFacmanUserSites?:  {
    __typename: "FacmanUserSites",
    sitesTotal?: number | null,
    sites?:  Array< {
      __typename: "FacmanSite",
      siteId: string,
      siteName: string,
      region?: string | null,
      siteType?: string | null,
    } | null > | null,
    error?: string | null,
  } | null,
};

export type ListSigInfraUserSitesQueryVariables = {
  path?: string,
};

export type ListSigInfraUserSitesQuery = {
  listSIGInfraUserSites?:  Array< {
    __typename: "SIGInfraSite",
    SiteCode: string,
    AccessLevelName: string,
    BadgeKey: number,
    BadgeID: number,
    Login: string,
    Region?: string | null,
  } | null > | null,
};

export type GetDeviceStatusQueryVariables = {
  queryStringParameters?: GetDeviceStatusInput,
};

export type GetDeviceStatusQuery = {
  getDeviceStatus?:  {
    __typename: "DeviceStatus",
    device_key?: string | null,
    parent_id?: number | null,
    child_id?: number | null,
    subchild_id?: number | null,
    site_code?: string | null,
    device_type?: string | null,
    masked?: boolean | null,
    masked_timestamp?: string | null,
    intrusion_report?: string | null,
    intrusion_report_timestamp?: string | null,
    alarm?: boolean | null,
    alarm_timestamp?: string | null,
    line_error?: boolean | null,
    line_error_timestamp?: string | null,
    open_line?: boolean | null,
    open_line_timestamp?: string | null,
    shorted_line?: boolean | null,
    shorted_line_timestamp?: string | null,
    grounded_loop?: boolean | null,
    grounded_loop_timestamp?: string | null,
    relay_contact?: boolean | null,
    relay_contact_timestamp?: string | null,
    comm_loss?: boolean | null,
    comm_loss_timestamp?: string | null,
    comm_loss_host?: boolean | null,
    comm_loss_host_timestamp?: string | null,
    door_forced?: boolean | null,
    door_forced_timestamp?: string | null,
    door_held?: boolean | null,
    door_held_timestamp?: string | null,
    reader_mode?: string | null,
    reader_mode_timestamp?: string | null,
    full_panel_download?: boolean | null,
    full_panel_download_timestamp?: string | null,
    cabinet_tamper?: boolean | null,
    cabinet_tamper_timestamp?: string | null,
    power_failure?: boolean | null,
    power_failure_timestamp?: string | null,
    door_held_masked?: boolean | null,
    door_held_masked_timestamp?: string | null,
    door_forced_masked?: boolean | null,
    door_forced_masked_timestamp?: string | null,
    comm_path?: boolean | null,
    comm_path_timestamp?: string | null,
    last_update_epoch_utc?: string | null,
  } | null,
};

export type GetUserPrefsQueryVariables = {
  username?: string,
};

export type GetUserPrefsQuery = {
  getUserPrefs?:  {
    __typename: "UserPrefs",
    username: string,
    inputs?:  {
      __typename: "InputsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "InputsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    lastSite?:  {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null,
    readersAlarms?:  {
      __typename: "ReadersAlarmsPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    readersModes?:  {
      __typename: "ReadersModesPrefs",
      numRecordsPerPage?: number | null,
      emailAddresses?: string | null,
      savedSearches?:  Array< {
        __typename: "ReadersAlarmsSavedSearch",
        name: string,
        filterText?: string | null,
        maskStatus?: string | null,
        modes?: Array< string | null > | null,
      } | null > | null,
    } | null,
    site?: string | null,
    sites?:  Array< {
      __typename: "UserPrefSite",
      sitename: string,
      siteRegion?: string | null,
    } | null > | null,
  } | null,
};
